import { pipe, RA, RR } from '@packages/prelude'
import * as domain from '@packages/domain'
import type { Configuration } from '~/store'

/**
 * Check if step should be rendered
 */
export const shouldRenderStep = (step: domain.Step.Type, visibleOptionalSteps: ReadonlySet<domain.StepId.Type>): boolean =>
  step.optional === false || visibleOptionalSteps.has(step.id)

/**
 * Get visible optional steps
 */
export const visibleOptionalSteps = (state: Configuration.State): ReadonlySet<domain.StepId.Type> => {
  return pipe(
    state.selectedOptions,
    RR.values,
    RA.flatten,
    RA.chain(option => option.referencedStepIds),
    RA.uniq(domain.StepId.Eq),
    stepIds => new Set(stepIds)
  )
}

/**
 * Get visible steps - derived from allSteps and enabledSteps
 * Filters optional steps based on visibility logic and sorts by order field
 */
export const visibleSteps = (state: Configuration.State): ReadonlyArray<domain.Step.Type> => {
  const visibleOptionalStepsSet = visibleOptionalSteps(state)

  return pipe(
    state.allSteps,
    RA.filter(step => shouldRenderStep(step, visibleOptionalStepsSet)),
    RA.sort(domain.Step.Ord) // Sort by order field
  )
}
